/* stylelint-disable selector-max-compound-selectors */

$circle-size: rem(6330);
$circle-size-mobile: rem(1340);
$ethis-top-position: rem(270);
$ethis-top-position-mobile: rem(220);

$footer--top-background-color: var(--footer--top-background-color, #{$grey-light});

:host {
  @include reset-host;
}

:host .footer {
  @include z-index('base'); // for the Ethis visual to be on top of section above

  position: relative;

  padding: rem(100) $gutter rem(30);
  overflow: hidden;

  background: $footer--top-background-color;

  @include mq('max', 'md') {
    padding: rem(40) $gutter-mobile rem(20);

    background: $white;
  }

  .content {
    position: relative;

    max-width: $max-width;
    margin: 0 auto;
    padding-top: rem(45);

    color: $white;

    @include mq('max', 'md') {
      padding-top: rem(40);
    }

    // purple background circle
    &:before {
      position: absolute;
      top: 0;
      left: calc((#{$circle-size} / -2.1));
      z-index: -1;

      width: $circle-size;
      height: $circle-size;

      background: $color-purple;
      border-radius: 50%;

      content: '';

      @include mq('max', 'md') {
        left: 50%;

        width: $circle-size-mobile;
        height: $circle-size-mobile;

        transform: translateX(-50%);
      }
    }
  }

  .top {
    display: flex;
    gap: rem(40);
    align-items: flex-end;
    justify-content: space-between;

    @include mq('max', 'md') {
      flex-direction: column;
      gap: rem(24);
      align-items: center;
    }
  }

  .text-wrapper {
    --paragraph-color: #{$white};
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    max-width: rem(450);

    @include mq('max', 'md') {
      align-items: center;

      text-align: center;
    }
  }

  .button-wrapper {
    margin-top: rem(16);

    @include mq('max', 'md') {
      margin-top: rem(30);
    }

    @include mq('max', 'xs') {
      width: 100%;
    }

    efb-button {
      display: block;
    }
  }

  .dividing-line {
    width: 100%;
    height: 1px;
    margin-top: rem(64);
    margin-bottom: rem(16);

    background: $color-purple-light;
    border-width: 0;

    @include mq('max', 'md') {
      margin-top: rem(40);
    }
  }

  .bottom {
    display: flex;
    flex-wrap: wrap;
    gap: rem(40);
    justify-content: space-between;

    color: $color-purple-light;
    font-size: $fs-sm;

    @include mq('max', 'md') {
      gap: rem(15);
    }
  }

  .legal-links {
    display: flex;
    flex-wrap: wrap;
    gap: rem(16);

    list-style: none;
  }

  .legal-links-item a {
    color: inherit;
  }

  .legal-links-item button {
    padding: 0;

    color: inherit;
    text-decoration: underline;

    background: transparent;
    border: 0;
    cursor: pointer;
  }
}

:host .footer.has-background-visual {
  // margin-top: rem(-150);
  padding-top: $ethis-top-position;

  @include mq('max', 'md') {
    // margin-top:
    padding: $ethis-top-position-mobile $gutter-mobile rem(20);
    padding: $ethis-top-position-mobile $gutter-mobile rem(20);

    background: $footer--top-background-color;
  }

  .ethi-visual {
    position: absolute;
    top: -$ethis-top-position;
    right: rem(-50);
    z-index: -2; // behind purple circle

    @include mq('max', 'md') {
      top: -$ethis-top-position-mobile;
    }

    .img {
      width: rem(480);
      height: auto;

      @include mq('max', 'md') {
        top: -$ethis-top-position-mobile;

        width: rem(345);
        height: auto;
      }
    }

    .ethi-baseline {
      position: absolute;
      bottom: rem(240);
      left: rem(-80);

      color: $color-purple;
      font-size: rem(36);
      font-family: $ff-title;
      line-height: 1.1;
      text-align: center;

      text-shadow: 2px 2px $white;

      transform: rotate(-9deg);

      @include mq('max', 'md') {
        bottom: rem(190);
        left: rem(-50);

        font-size: rem(30);
      }
    }
  }
}
